<template>
  <div class="breadcrumb">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>当前位置:</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>{{titleText}}</el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>
<script>
export default {
  props:{
    tabTitle:[String,Number]
  },
  data(){
    return {
      titleText:''
    }
  },
  created(){
    this.getType()
  },
  methods:{
    getType(){
      if(this.tabTitle == '422'){
        this.titleText = '电商学习'
      }else if(this.tabTitle == '62'){
        this.titleText = '企业管理'
      }else if(this.tabTitle == '424'){
        this.titleText = '新闻资讯'
      }else if(this.tabTitle == '425'){
        this.titleText = '企业家专区'
      }else if(this.tabTitle == '426'){
        this.titleText = '生意经'
      }else if(this.tabTitle == '427'){
        this.titleText = '创业区'
      }else if(this.tabTitle == '428'){
        this.titleText = '新鲜事'
      }else if(this.tabTitle == '429'){
        this.titleText = '大杂烩'
      }else{
        this.titleText = '其他'
      }
    }
  },
  computed:{
    title(){
      return this.tabTitle
    }
  },
  watch:{
    title(){
      this.getType()
    }
  }
}
</script>
<style scoped lang="scss">
.breadcrumb {
  margin-bottom: 22px;
  .el-breadcrumb__inner {
    color: #187adc !important;
    font-size: 26px;
  }

}
</style>